import { GzExchangeProtectionUserGroupsGridWebComponent } from './component/GzExchangeProtectionUserGroupsGridWebComponent';

export { GzExchangeProtectionUserGroupsGridWebComponent };
